import { Avatar } from '@hivebrite/design-system/Avatar';
import { Box } from '@hivebrite/design-system/Box';
import { Link } from '@hivebrite/design-system/Link';

import { useJobContext } from 'hb-react/frontoffice/apps/JobsV2/contexts/JobContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import ClampedLinkWorkaround from 'hb-react/shared/components/DesignSystem/ClampedLinkWorkaround';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import dayjs from 'hb-react/shared/utils/dayjs/dayjs';
import { completeName } from 'helpers/name';

const avatarFallbackImage = '/images/missing/user_avatar/large.jpg';

const PostedBy = ({ children, authorUrl }) =>
  authorUrl ? (
    <Link styledOnlyOnHover to={authorUrl}>
      {children}
    </Link>
  ) : (
    children
  );

const Author = () => {
  const { currentUser } = useDefaultAppContexts();
  const { flagEvUserPicturesToGlobalStorage } = useFeatureFlag();
  const {
    user: jobUser,
    external_provider: externalProvider,
    created_at: createdAt,
    parent_name: parentName,
    parent_avatar: parentAvatar,
  } = useJobContext();

  const showAvatar = jobUser || !externalProvider;

  const jobUserAvatarUrl = flagEvUserPicturesToGlobalStorage
    ? jobUser?.new_photo?.thumbnail_url
    : jobUser?.photo_thumb_url;

  const avatarUrl = jobUser ? jobUserAvatarUrl : parentAvatar;

  const authorUrl = jobUser ? Routes.user_path(jobUser.id) : null;

  const postedBy =
    !jobUser && externalProvider === 'multiposting'
      ? I18n.t('web.business_opportunities.card.external_offer')
      : s__('JobsV2|Posted by %{name}').i__({
          name: jobUser ? completeName(jobUser) : parentName,
        });

  return (
    <Box mt={6} alignItems="center">
      {showAvatar && (
        <Avatar
          src={avatarUrl || avatarFallbackImage}
          href={authorUrl}
          width="60px"
          height="60px"
          alt={
            jobUser ? `Profile picture of ${jobUser.name}` : 'Network avatar'
          }
        />
      )}
      <Box flexDirection="column" px={4}>
        {currentUser && (
          <ClampedLinkWorkaround clamp={2}>
            <Box font="h4-semibold">
              <PostedBy authorUrl={authorUrl}>{postedBy}</PostedBy>
            </Box>
          </ClampedLinkWorkaround>
        )}
        <Box font="metadata-regular-asphalt">{dayjs(createdAt).fromNow()}</Box>
      </Box>
    </Box>
  );
};

export default Author;
